import React from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LayoutDashboard, Users, Swords, Table2, Coins, Trophy, Settings, Tv, LogOut, Gift, Target as TargetIcon, MessagesSquare, ShieldCheck, Wallet, ShoppingBag } from "lucide-react";
import { LogoIcon } from "@/components/Logo";

const buildSurfaceUrl = (sub, path = "/") => {
  const host = window.location.hostname;
  const apex = host.replace(/^(admin|tv|app)\./, "");
  return `${window.location.protocol}//${sub ? sub + "." : ""}${apex}${path}`;
};

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "admin-nav-dashboard" },
  { to: "/admin/players", label: "Người chơi", icon: Users, testid: "admin-nav-players" },
  { to: "/admin/verifications", label: "Xác thực", icon: ShieldCheck, testid: "admin-nav-verifications" },
  { to: "/admin/arena", label: "Đấu trường", icon: TargetIcon, testid: "admin-nav-arena" },
  { to: "/admin/matches", label: "Trận đấu", icon: Swords, testid: "admin-nav-matches" },
  { to: "/admin/wallet", label: "Ví tiền", icon: Wallet, testid: "admin-nav-wallet" },
  { to: "/admin/tables", label: "Bàn bida", icon: Table2, testid: "admin-nav-tables" },
  { to: "/admin/rewards", label: "Đổi quà", icon: Gift, testid: "admin-nav-rewards" },
  { to: "/admin/items", label: "Vật phẩm", icon: ShoppingBag, testid: "admin-nav-items" },
  { to: "/admin/tv", label: "TV Display", icon: Tv, testid: "admin-nav-tv" },
  { to: "/admin/leaderboard", label: "Bảng xếp hạng", icon: Trophy, testid: "admin-nav-leaderboard" },
  { to: "/admin/settings", label: "Cài đặt", icon: Settings, testid: "admin-nav-settings" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-[#05050a] flex">
      <aside className="hidden lg:flex w-64 flex-col border-r border-white/5 bg-[#070810] p-5">
        <Link to="/admin" className="flex items-center gap-2.5 mb-8">
          <LogoIcon size={40} />
          <div>
            <div className="font-display font-bold text-sm leading-none">ADMIN</div>
            <div className="text-[10px] text-amber-400/80 tracking-[0.25em] mt-1">CONTROL</div>
          </div>
        </Link>

        <nav className="flex-1 flex flex-col gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testid}
              className={({ isActive }) =>
                `px-3 py-2.5 rounded-md text-sm flex items-center gap-3 transition ${isActive ? "bg-cyan-400/10 text-cyan-300 border border-cyan-400/30" : "text-white/60 hover:text-white hover:bg-white/5 border border-transparent"}`
              }
            >
              <n.icon size={16} /> {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-6 space-y-2">
          <a href={buildSurfaceUrl("tv", "/tv")} target="_blank" rel="noreferrer" className="px-3 py-2.5 rounded-md text-sm flex items-center gap-3 border border-cyan-400/30 text-cyan-300 hover:bg-cyan-400/10" data-testid="admin-open-tv">
            <Tv size={16} /> Mở TV Display
          </a>
          <a href={buildSurfaceUrl("app", "/")} className="px-3 py-2.5 rounded-md text-sm flex items-center gap-3 text-white/60 hover:bg-white/5">
            ← App người chơi
          </a>
          <div className="border-t border-white/10 pt-3 mt-3 flex items-center gap-2">
            <img src={user?.avatar_url} alt="" className="w-8 h-8 rounded-full" />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium truncate">{user?.nickname}</div>
              <div className="text-[10px] text-cyan-300 uppercase tracking-wider">{user?.role}</div>
            </div>
            <button onClick={logout} className="p-2 rounded-md hover:bg-white/5 text-white/60" data-testid="admin-logout"><LogOut size={14} /></button>
          </div>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        {/* mobile top bar */}
        <div className="lg:hidden flex items-center justify-between px-4 h-14 border-b border-white/5 bg-[#070810]">
          <Link to="/admin" className="font-display font-bold text-sm">ADMIN · BILLIARDS</Link>
          <a href={buildSurfaceUrl("app", "/")} className="text-xs text-cyan-300">App ↗</a>
        </div>
        <Outlet />
      </main>
    </div>
  );
}
